import React from 'react';
import SeguroService from '../../../../lib/api/seguro/seguroService';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class Seguro extends React.Component<{},{}> 
{
    constructor(props: any) 
    {
        super(props);
        this.state = {};
    }

    baixarExcelSeguro()
    {
        return SeguroService.obterExcel()
    }

    enviarParametrosEventGrid() 
    {
        return SeguroService.enviarParametrosAoEventGrid();
    }
    
    render() 
    {
        return (
            <TemplateParametro
                enviarParametrosEventGrid={this.enviarParametrosEventGrid}
                baixarExcelParametros={this.baixarExcelSeguro}
                enviarExcelParametros={SeguroService.enviarExcelParametros}
                deletarExcelParametros={SeguroService.deletarExcelParametros}
                nomeDoArquivo='Parametros MIP e DFI'
            ></TemplateParametro>
        );
    }
}

export default Seguro